import GAgendaContainer from "@/modules/agenda/containers/GAgendaContainer.tsx";

import * as agendaRoutes from "./AgendaRoutes";
import AgendaContainer from "../containers/AgendaContainer";


export const AgendaRoutes = [
  {
    key: "agenda",
    exact: true,
    path: agendaRoutes.AGENDA,
    component: AgendaContainer,
  },
  {
    key: "gagenda",
    exact: true,
    path: agendaRoutes.GAGENDA,
    component: GAgendaContainer,
  },
];
